import { Component } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { RegionService } from '../../services/region.service';

@Component({
  selector: 'email-body',
  templateUrl: './email-body.html'
})
export class EmailBodyComponent {

  constructor (
    public regionService: RegionService,
    public sessionService: SessionService
  ) { }
}



// WEBPACK FOOTER //
// ./src/components/email-body/email-body.component.ts